
import { useBreakpoints, breakpointsTailwind } from "@vueuse/core";
import { defineComponent } from "vue";
const breakpoints = useBreakpoints(breakpointsTailwind);
const sm = breakpoints.smaller("sm");
export default defineComponent({
  name: "Pyramid",
  setup() {
    return {
      sm,
    };
  },
});
